import FormSubmissionChart from "../../../components/charts/formSubmittedChart";
import MonthlyWebsiteVisits from "../../../components/charts/LineChart";
import ProductContributionChart from "../../../components/charts/productIntrestChart";
import ProductServiceBarChart from "../../../components/charts/productsServiceChart";
import ServiceInterestChart from "../../../components/charts/serviceIntrestChart";
import React, { useState, useEffect } from 'react';
import { database, ref, get } from '../../../firebase.config';
import { useWebsiteCounter } from "../../../hooks/useWebsiteCounter";
import { useProductCounter } from "../../../hooks/useProductCounter";
import ServiceCountChart from "../../../components/charts/serviceCountChart";
import { useServiceCounter } from "../../../hooks/useServiceCounter";
import { useContactEnquiry } from "../../../hooks/useContactEnquiry";
import { useProductEnquiry } from "../../../hooks/useProductEnquiry";
import { useServiceEnquiry } from "../../../hooks/useServiceEnquiry";
export const Analytics = () => {
    const [websiteVisitors, setWebsiteVisitors] = useState(0); // Default value
    const { totalCount, isLoading } = useWebsiteCounter();
    const { totalCount: productTotal, isLoading: productLoading } = useProductCounter();
    const { totalCount: serviceTotal, isLoading: serviceLoading } = useServiceCounter();
    const { totalCount: contactETotal} = useContactEnquiry();
    const { totalCount: productETotal } = useProductEnquiry();
    const { totalCount: serviceETotal } = useServiceEnquiry();

    const stats = [
        { label: "Website Visitors", value: isLoading ? "_" : totalCount.toLocaleString() },
        { label: "Products Page Visitors", value: productLoading ? "_" : productTotal.toLocaleString() },
        { label: "Services Page Visitors", value: serviceLoading ? "_" : serviceTotal.toLocaleString() },
        { label: "Total Enquiries", value: contactETotal + productETotal + serviceETotal },
    ];



    return (
        <div className="">

            {/* Page Heading */}
            <div className="mb-8">
                <h2 className="text-[36px] font-bold font-barlow text-gray-700">
                    Analytics
                </h2>
                <p className="mt-1 text-sm text-gray-600">
                    Website performance, product engagement, and service interest insights
                </p>
            </div>

            {/* Top Summary Tiles */}
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 mb-10">
                {stats.map((stat, index) => (
                    <div
                        key={index}
                        className="bg-white shadow-sm rounded-lg p-5 flex flex-col items-start transition-shadow duration-300 border-[1px]"
                    >
                        <p className="text-sm font-medium text-gray-500">{stat.label}</p>
                        <p className="mt-2 text-2xl font-bold text-gray-900">{stat.value.toLocaleString()}</p>
                    </div>
                ))}
            </div>

            {/* Charts Grid */}
            <div className="grid grid-cols-1 gap-6 sm:grid-cols-2">
                <MonthlyWebsiteVisits />
                <ProductServiceBarChart />

                <ProductContributionChart />
                {/* <ServiceInterestChart /> */}

                {/* <FormSubmissionChart /> */}
                <ServiceCountChart />
            </div>



        </div>
    );
};

